import { useSuspenseQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { LeadDistributionPreference } from 'src/shared/features/enterprise/api/use-update-enterprise-settings'

export interface EnterpriseDistributionSystemResponse {
  id: number
  enterpriseId: number
  name: string
  distributionType: LeadDistributionPreference
  memberUserIds: number[]
  createdAt: string
  updatedAt: string
  isDefault: boolean
}

const listEnterpriseDistributionSystems = async (enterpriseId: number) => {
  const response = await getRequest<EnterpriseDistributionSystemResponse[]>(
    `/enterprise/${enterpriseId}/distribution-systems`,
  )
  if (!response) {
    throw new Error('No response received from list distribution systems')
  }
  return response
}

interface UseLeadDistributionsParams {
  enterpriseId: number
}

export default function useLeadDistributions({ enterpriseId }: UseLeadDistributionsParams) {
  return useSuspenseQuery({
    ...queries.enterprise.distributionSystems(enterpriseId),
    queryFn: () => listEnterpriseDistributionSystems(enterpriseId),
  })
}
